// extracted by mini-css-extract-plugin
export var changeIcon = "_51-4";
export var container = "_51-0";
export var divider = "_51-7";
export var externalLinkIcon = "_51-1";
export var green = "_51-5";
export var helpCircleIcon = "_51-3";
export var iconButton = "_51-2";
export var red = "_51-6";